import type {
	ShopDto,
	UpdateOneShopCustomisationDto,
} from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateShopCustomization(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/preferences/customisations",
		{
			invalidate: invalidateShop,
			mapVariables: (data: UpdateOneShopCustomisationDto) => ({
				params: { path: { shopId: shop.id } },
				body: data,
			}),
		},
	);
}
